import initializeDeviceGUIDListener from './initializeDeviceGUIDListener';
import requestExtensionForDeviceGUID from './requestExtensionForDeviceGUID';
import { initializeBootDataListener } from './initializeBootDataListener';
import { initializePushSubscriptionDataListener } from './initializePushSubscriptionDataListener';
import { requestExtensionForMailBootData } from './requestExtensionForMailBootData';
import { USE_STARTUP_DATA_FROM_EXTENSION } from '../constants/useDataFromExtension';
import { initializeScreenShotListener } from 'extension-communication/lib/handlers/initializeScreenShotListener';

export const initializeMessageCommunication = (): void => {
    // Registers listener to get message from extension
    initializeBootDataListener();

    // Registers listener to get push subscription data from extension
    initializePushSubscriptionDataListener();

    // Registers listener to accept Device GUID from the extension
    initializeDeviceGUIDListener();

    // Registers listener to show screenshots in compose
    initializeScreenShotListener();

    // Requests extension to send Device GUID
    requestExtensionForDeviceGUID();

    if (USE_STARTUP_DATA_FROM_EXTENSION) {
        // Notify the host (extension) to send Mail boot data
        requestExtensionForMailBootData();
    }
};
